// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"bd974808","513":"e4f92e66","703":"fd7a9280","890":"754a5fd4"}[chunkId] + ".chunk.js";
};